module.exports = __webpack_public_path__ + "static/media/logo-fidelys.c41da3ff.jpeg";